import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyBQW-_RnUs-DGBAXFhrJSgx-JEticGIfAs",
  authDomain: "laofi-f175b.firebaseapp.com",
  projectId: "laofi-f175b",
  storageBucket: "laofi-f175b.appspot.com",
  messagingSenderId: "276615378822",
  appId: "1:276615378822:web:b96039113e61e4092c1e07",
  measurementId: "G-8JGB2HY8S5"
};

const appFirebase = initializeApp(firebaseConfig);
const analytics = getAnalytics(appFirebase);
const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);
const storage = getStorage(appFirebase);
export { db, storage, auth, analytics };
export default appFirebase;